$(document).ready(function() {
  $('.designDetails__list--slider').on('init', function (event, slick) {
    changeProgressBar(slick, 0);
  });

  $('.designDetails__list--slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    changeProgressBar(slick, nextSlide);
  });

  function changeProgressBar(slick, nextSlide) {
    let calc = ((nextSlide + 1) / (slick.slideCount - 2)) * 100,
        progressBar = $('.designDetails__barProgress');

    if (window.innerWidth <= 768) {
      calc = ((nextSlide + 1) / (slick.slideCount - 0.35)) * 100;
    }

    progressBar.css({'width': `${calc}%`});
  }

  $('.designDetails__list--slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 3.35,
    slidesToScroll: 1,
    prevArrow: "<span class='designDetails__prevButton'></span>",
    nextArrow: "<span class='designDetails__nextButton'></span>",
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1.35,
          dots: false
        }
      }
    ]
  });
});
